import { toast } from "react-toastify";

export async function CopyToClipboard(copyString: string, successMessage: string) {
    //TODO: Make this depend on environmnet (dev/prod)
    await navigator.clipboard.writeText(copyString);
    toast.success(successMessage)
}